import { render, staticRenderFns } from "./Workbench.vue?vue&type=template&id=02c54efb&scoped=true"
import script from "./Workbench.vue?vue&type=script&lang=js"
export * from "./Workbench.vue?vue&type=script&lang=js"
import style0 from "./Workbench.vue?vue&type=style&index=0&id=02c54efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c54efb",
  null
  
)

export default component.exports